import { inventoryItemIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

/** Verify-scan step: records the gun-scanned tracking number on the item's latest shipping label scan. */
export const setShippingLabelScanTracking = {
  name: "setShippingLabelScanTracking" as const,
  input: z.object({
    inventoryItemId: inventoryItemIdFormat.schema,
    scannedValue: z.string(),
  }),
  output: z.object({ trackingNumber: z.string() }),
};
